import { render } from "./Checkbox.vue?vue&type=template&id=d76be9c0&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=d76be9c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d76be9c0"

export default script